import React from 'react';
import SideDrawer from '../SideDrawer';
import SingleCalculatedTypeEditor from './SingleCalculatedTypeEditor';
import { Button } from 'gd-react';

class ForwardDataTypesDrawer extends React.Component {
    constructor(props) {
        super(props);
        this.state = {
            hasChanges: false
        };
        
        this.onChange = this.onChange.bind(this);
        this.handleSave = this.handleSave.bind(this);
        this.handleCancel = this.handleCancel.bind(this);
    }

    onChange(updatedType) {
        this.setState({ hasChanges: true });
        if (this.props.onChange) {
            const { value, editingType } = this.props;
            const updatedValue = {
                ...value,
                [editingType]: {
                    dataType: updatedType.dataType,
                    calculation: updatedType.calculation
                }
            };
            this.props.onChange(updatedValue);
        }
    }

    handleSave() {
        if (this.props.onSave) {
            this.props.onSave();
        }
        this.setState({ hasChanges: false });
    }

    handleCancel() {
        if (this.props.onCancel) {
            this.props.onCancel();
        }
        this.setState({ hasChanges: false });
    }

    render() {
        const { open, onClose, value, asset, editingType, title = "Calculated Data Types" } = this.props;
        const { hasChanges } = this.state;

        if (!editingType || !value[editingType]) {
            return null;
        }

        const currentType = value[editingType];
        const titleWithType = `Edit: ${editingType}`;

        const footer = (
            <div className="drawer-footer-actions">
                <Button
                    label="Cancel"
                    onClick={this.handleCancel}
                    additionalclasses="sm"
                />
                <Button
                    label="Save Changes"
                    color="gd-green"
                    onClick={this.handleSave}
                    disabled={!hasChanges}
                    additionalclasses="sm"
                />
            </div>
        );

        return (
            <>
                {open && (
                    <SideDrawer
                        onClose={onClose}
                        title={titleWithType}
                        footer={footer}
                        wide={true}
                    >
                        <SingleCalculatedTypeEditor
                            typeKey={editingType}
                            dataType={currentType.dataType}
                            calculation={currentType.calculation}
                            onChange={this.onChange}
                        />
                    </SideDrawer>
                )}
            </>
        );
    }
}

export default ForwardDataTypesDrawer;
